import {
  EventStatusPoints,
  IEventStatus,
} from "core-integration/src/store/events/types";
import { ReadableStatus } from "./types";

/** Map API returned IEventStatus.points values to readable value */
export const PointsStatus = {
  notStarted: "",
  live: "l",
  provisional: "p",
  confirmed: "r",
} as const as Record<ReadableStatus, EventStatusPoints>;

/**
 * Returns the correct status value based on a day's points.
 * If bonus_added is true, treat as confirmed even when points is provisional
 * (can happen when confirmed points data is re-checked and reverted to provisional state).
 */
export const getReadableStatus = (status: IEventStatus): ReadableStatus => {
  const confirmed =
    status.points === PointsStatus.confirmed || status.bonus_added;

  if (confirmed) {
    return "confirmed";
  }
  if (status.points === PointsStatus.live) {
    return "live";
  }
  if (status.points === PointsStatus.provisional) {
    return "provisional";
  }
  return "notStarted";
};
